// Companies
export const LOAD_CONFING_SYNC_COMPANIES = "LOAD_CONFIG_SYNC_COMPANIES";
export const SET_CONFIG_SYNC_COMPANIES = "SET_CONFIG_SYNC_COMPANIES";
export const CLEAR_CONFIG_SYNC_COMPANIES = "CLEAR_CONFIG_SYNC_COMPANIES";
export const ERROR_CONFIG_SYNC_COMPANIES = "ERROR_CONFIG_SYNC_COMPANIES";
// Units
export const LOAD_CONFIG_SYNC_UNITS = "LOAD_CONFIG_SYNC_UNITS";
export const SET_CONFIG_SYNC_UNITS = "SET_CONFIG_SYNC_UNITS";
export const CLEAR_CONFIG_SYNC_UNITS = "CLEAR_CONFIG_SYNC_UNITS";
export const ERROR_CONFIG_SYNC_UNITS = "ERROR_CONFIG_SYNC_UNITS";
// Stations
export const LOAD_STATIONS_CONFIG = "LOAD_STATIONS_CONFIG"